import type { Document } from "mkm-types";
import { client } from "../client";

export const getInvoices = async (): Promise<Array<Document> | undefined> => {
  const response = await client.get("/getInvoices");

  return response.data;
};
